import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Study } from '../../../../shared/api/hscan/hospital';
import { Spacer } from '../../common/components/Spacer';
import {
  SectionContentContainer,
  SectionHeading,
} from '../../common/components/styledComponents';

import { MedicalImageTable } from './MedicalImageTable';
import { PeriodFilteringButtons } from './PeriodFilteringButtons';

interface SelectImageSectionProps {
  isLoadingQueriedStudies: boolean;
  searched: boolean;
  studies: Study[];
  selected: readonly string[];
  selectOne: (key: string) => void;
  selectAll: (checked: boolean, studies: Study[]) => void;
  unselectAll: () => void;
}
export const SelectImageSection = (props: SelectImageSectionProps) => {
  const {
    isLoadingQueriedStudies,
    searched,
    studies,
    selected,
    selectOne,
    selectAll,
    unselectAll,
  } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.request.imageList',
  });

  const [periodFilteringFunction, setPeriodFilteringFunction] = useState<
    (study: Study) => void
  >(() => () => null);
  const filteredStudies = useMemo(
    () => studies.filter((study: Study) => periodFilteringFunction(study)),
    [periodFilteringFunction, studies],
  );
  const [page, setPage] = useState(0);

  useEffect(() => {
    setPage(0);
    unselectAll();
  }, [unselectAll, filteredStudies]);

  return (
    <SectionContentContainer>
      <SectionHeading>{t('heading')}</SectionHeading>
      <Spacer height={37} />
      <PeriodFilteringButtons
        setPeriodFilteringFunction={setPeriodFilteringFunction}
        reset={searched}
      />
      <Spacer height={10} />
      <MedicalImageTable
        isLoading={isLoadingQueriedStudies}
        data={filteredStudies}
        page={page}
        onChangePage={setPage}
        selected={selected}
        onSelect={selectOne}
        onSelectAll={(checked, studies) => selectAll(checked, studies)}
        unselectAll={unselectAll}
        searched={searched}
      />
    </SectionContentContainer>
  );
};
